/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsSummaryNftData model module.
 * @module model/StatisticsSummaryNftData
 * @version 1.0
 */
class StatisticsSummaryNftData {
    /**
     * Constructs a new <code>StatisticsSummaryNftData</code>.
     * @alias module:model/StatisticsSummaryNftData
     */
    constructor() { 
        
        StatisticsSummaryNftData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsSummaryNftData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsSummaryNftData} obj Optional instance to populate.
     * @return {module:model/StatisticsSummaryNftData} The populated <code>StatisticsSummaryNftData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsSummaryNftData();

            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsSummaryNftData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsSummaryNftData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} grade
 */
StatisticsSummaryNftData.prototype['grade'] = undefined;

/**
 * @member {Number} count
 */
StatisticsSummaryNftData.prototype['count'] = undefined;






export default StatisticsSummaryNftData;

